var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21.281 5.87c-.7.311-1.454.521-2.245.616a3.92 3.92 0 001.719-2.164 7.807 7.807 0 01-2.483.948 3.91 3.91 0 00-6.663 3.568 11.104 11.104 0 01-8.06-4.086 3.911 3.911 0 001.21 5.221 3.901 3.901 0 01-1.771-.49v.05a3.912 3.912 0 003.137 3.835 3.938 3.938 0 01-1.767.067 3.912 3.912 0 003.654 2.715 7.847 7.847 0 01-5.79 1.62 11.059 11.059 0 005.993 1.757c7.194 0 11.126-5.958 11.126-11.126 0-.167-.004-.337-.011-.505a7.95 7.95 0 001.95-2.023l.001-.002z","fill":"#727183"}));
}

Twitter.defaultProps = {"width":"23","height":"23","viewBox":"0 0 23 23","fill":"none"};

module.exports = Twitter;

Twitter.default = Twitter;
